<script setup lang="ts">
import SortByFilter from '@/components/Filters/SortByFilter.vue'
import { StackLayout } from '@/components/Layouts'
import { ESortBy, ESortByDate } from '@/types/enum/SortByEnum'
import type { DeviceHistoryModel } from '@/types/models/DeviceHistoryModel'
import DebouncedInputField from '../../../../Fields/DebouncedInputField.vue'

type Props = {
    filters?: Partial<DeviceHistoryModel>
    sort: ESortBy
}
defineProps<Props>()
type Emits = {
    (e: 'changeSortBy', value: ESortBy): void
    (e: 'changeFilters', value: Partial<DeviceHistoryModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="8" class="space-between">
        <DebouncedInputField
            :label="$t('device.detail.history.filters.name')"
            :modelValue="filters?.name"
            @change="$emit('changeFilters', { name: $event })" />
        <SortByFilter
            :sortBy="sort"
            :options="ESortByDate"
            @click="$emit('changeSortBy', $event)"
            class="fit-content" />
    </StackLayout>
</template>

<style scoped lang="scss">
.key-name {
    color: $primary;
}
.modified-by {
    color: $primary;
    color: var(--color-text-secondary);
}
.user-name {
    color: var(--color-text-secondary);
}
</style>
